import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SetPassword.css"; // reutilizamos los estilos del reset/set password

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      // 🔹 Llamada al backend
      await fetch("http://te-ayudo.es/back/api/forgot_password.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      // ✅ Mensaje genérico (sin revelar si el correo existe o no)
      setMessage(
        "Si el correo existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña."
      );
    } catch (err) {
      setMessage("Error al conectar con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-container">
      <h2>🔑 Recuperar contraseña</h2>

      <form onSubmit={handleSubmit} className="password-form">
        <label>Correo electrónico</label>
        <input
          type="email"
          placeholder="usuario@ejemplo.com"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Enviando..." : "Enviar enlace"}
        </button>

        {message && <p className="message">{message}</p>}
      </form>

      <p className="back-link" onClick={() => navigate("/")}>
        ← Volver al inicio de sesión
      </p>
    </div>
  );
}
